import _regeneratorRuntime from "/workspace/node_modules/@babel/runtime/regenerator";
import _slicedToArray from "/workspace/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _asyncToGenerator from "/workspace/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import { addressesEqual, ANY_ENTITY } from '../address';
import { getKernelNamespace } from '../kernel';
/**
 * Look for known addresses and roles in a radspec description and substitute them with a human string
 *
 * @param  {string} description
 * @return {Promise<Object>} Description and annotated description
 */

export function postprocessRadspecDescription(_x, _x2) {
  return _postprocessRadspecDescription.apply(this, arguments);
}

function _postprocessRadspecDescription() {
  _postprocessRadspecDescription = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee(description, apps) {
    var addressRegexStr, addressRegex, bytes32RegexStr, bytes32Regex, combinedRegex, tokens, roles, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, app, appRoles, annotateAddress, annotateBytes32, annotateText, annotatedTokens, compiled;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            addressRegexStr = '0x[a-fA-F0-9]{40}';
            addressRegex = new RegExp("^".concat(addressRegexStr, "$"));
            bytes32RegexStr = '0x[a-f0-9]{64}';
            bytes32Regex = new RegExp("^".concat(bytes32RegexStr, "$"));
            combinedRegex = new RegExp("\\b(".concat(addressRegexStr, "|").concat(bytes32RegexStr, ")\\b"));
            tokens = description.split(combinedRegex).map(function (token) {
              return token.trim();
            }).filter(function (token) {
              return token;
            });

            if (!(tokens.length < 1)) {
              _context.next = 8;
              break;
            }

            return _context.abrupt("return", {
              description: description
            });

          case 8:
            roles = [];
            _iteratorNormalCompletion = true;
            _didIteratorError = false;
            _iteratorError = undefined;
            _context.prev = 12;
            _iterator = apps[Symbol.iterator]();

          case 14:
            if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
              _context.next = 23;
              break;
            }

            app = _step.value;
            _context.next = 18;
            return app.roles();

          case 18:
            appRoles = _context.sent;
            roles.concat(appRoles);

          case 20:
            _iteratorNormalCompletion = true;
            _context.next = 14;
            break;

          case 23:
            _context.next = 29;
            break;

          case 25:
            _context.prev = 25;
            _context.t0 = _context["catch"](12);
            _didIteratorError = true;
            _iteratorError = _context.t0;

          case 29:
            _context.prev = 29;
            _context.prev = 30;

            if (!_iteratorNormalCompletion && _iterator.return != null) {
              _iterator.return();
            }

          case 32:
            _context.prev = 32;

            if (!_didIteratorError) {
              _context.next = 35;
              break;
            }

            throw _iteratorError;

          case 35:
            return _context.finish(32);

          case 36:
            return _context.finish(29);

          case 37:
            annotateAddress = function annotateAddress(input) {
              if (addressesEqual(input, ANY_ENTITY)) {
                return [input, '"Any account"', {
                  type: 'any-account',
                  value: ANY_ENTITY
                }];
              }

              var app = apps.find(function (_ref) {
                var address = _ref.address;
                return addressesEqual(address, input);
              });

              if (app) {
                var replacement = "".concat(app.name).concat(app.appId ? " (".concat(app.appId, ")") : '');
                return [input, "\u201C".concat(replacement, "\u201D"), {
                  type: 'app',
                  value: app
                }];
              }

              return [input, input, {
                type: 'address',
                value: input
              }];
            };

            annotateBytes32 = function annotateBytes32(input) {
              var role = roles.find(function (_ref2) {
                var hash = _ref2.hash;
                return hash === input;
              });

              if (role && role.name) {
                return [input, "\u201C".concat(role.name, "\u201D"), {
                  type: 'role',
                  value: role
                }];
              }

              var app = apps.find(function (_ref3) {
                var appId = _ref3.appId;
                return appId === input;
              });

              if (app) {
                // return the entire app as it contains APM package details
                return [input, "\u201C".concat(app.appName, "\u201D"), {
                  type: 'apmPackage',
                  value: app
                }];
              }

              var namespace = getKernelNamespace(input);

              if (namespace) {
                return [input, "\u201C".concat(namespace.name, "\u201D"), {
                  type: 'kernelNamespace',
                  value: namespace
                }];
              }

              return [input, input, {
                type: 'bytes32',
                value: input
              }];
            };

            annotateText = function annotateText(input) {
              return [input, input, {
                type: 'text',
                value: input
              }];
            };

            annotatedTokens = tokens.map(function (token) {
              if (addressRegex.test(token)) {
                return annotateAddress(token);
              }

              if (bytes32Regex.test(token)) {
                return annotateBytes32(token);
              }

              return annotateText(token);
            });
            compiled = annotatedTokens.reduce( // eslint-disable-next-line @typescript-eslint/no-unused-vars
            function (acc, _ref4) {
              var _ref5 = _slicedToArray(_ref4, 3),
                  _ = _ref5[0],
                  replacement = _ref5[1],
                  annotation = _ref5[2];

              acc.description.push(replacement);
              acc.annotatedDescription.push(annotation);
              return acc;
            }, {
              annotatedDescription: [],
              description: []
            });
            return _context.abrupt("return", {
              annotatedDescription: compiled.annotatedDescription,
              description: compiled.description.join(' ')
            });

          case 43:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[12, 25, 29, 37], [30,, 32, 36]]);
  }));
  return _postprocessRadspecDescription.apply(this, arguments);
}